import FormControl from "@mui/material/FormControl";
import { useEffect, useRef, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import { getMetadatosWhereIdTipoContenidos } from "../../helpers/MetadatoData";
import { ContenidosFormDinamico } from "../ContenidosFormDinamico";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { Autocomplete, TextField } from "@mui/material";
import LoadingOverlay from "src/general_components/LoadingOverlay";
import { Grid } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import moment from "moment";

export const TipoContenidosSelectMetadatos = (data) => {

  const {
    toggleModalContenidosForm,
    id_cuentas_localizaciones,
    registroSeleccionado,
    updateList,
    tiposContenidos
  } = data;

  const [actualizarOptions, setActualizarOptions] = useState(false);

  let url = window.location.href;
  const arrUrl = url.split("/");
  const proceso = arrUrl[arrUrl.length - 1];

  const [metadatosList, setMetadatosList] = useState([]);
  const [inputsValues, setInputsValues] = useState(registroSeleccionado.meta_datos || []);
  const [isLoadingData, setIsLoadingData] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [message, setMessage] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [severity, setSeverity] = useState("");
  const [tipoContenidoSelectt, setTtipoContenidoSelect] = useState(data.tipoContenidoSelect || "");
  const [contenidosInfo, setContenidosInfo] = useState({
    id: "",
    id_cajas: "",
    id_tipo_contenidos: tipoContenidoSelectt,
    meta_datos: [],
  });
  const idTipoContenido = data?.tipoContenidoSelect?.id;
  const [objTipoContenido, setObjTipoContenido] = useState(data?.tipoContenidoSelect || null);

  const [localOcrCampos, setLocalOcrCampos] = useState(data.ocrCampos || []);
  const ocrAutoFilledRef = useRef(false);

  useEffect(() => {
    setLocalOcrCampos(data.ocrCampos || []);
    ocrAutoFilledRef.current = false;
  }, [data.ocrCampos]);

  // Auto-completar form cuando llegan metadatos + datos OCR con confianza suficiente
  useEffect(() => {
    if (ocrAutoFilledRef.current) return;
    if (metadatosList.length === 0 || localOcrCampos.length === 0) return;

    const umbral = data.ocrUmbral ?? 80;
    const autoFilledIds = new Set();
    const autoFilled = metadatosList.map(m => {
      if (m.valor && m.valor !== '') return m;
      const ocrMatch = localOcrCampos.find(
        c => c.id_metadatos
          && String(c.id_metadatos) === String(m.id)
          && c.valor
          && c.confianza !== null
          && c.confianza >= umbral
      );
      if (ocrMatch) {
        autoFilledIds.add(ocrMatch.globalIdx);
        return { ...m, valor: ocrMatch.valor };
      }
      return m;
    });

    if (autoFilledIds.size > 0) {
      ocrAutoFilledRef.current = true;
      setMetadatosList(autoFilled);
      setInputsValues(autoFilled);
      data.setMetadatos && data.setMetadatos(autoFilled);
      setLocalOcrCampos(prev =>
        prev.map(c => autoFilledIds.has(c.globalIdx) ? { ...c, applied: true } : c)
      );
      autoFilledIds.forEach(idx => data.onOcrApply && data.onOcrApply(idx));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadatosList, localOcrCampos]);

  const applyOcrField = (campo) => {
    setMetadatosList(prev => prev.map(m =>
      String(m.id) === String(campo.id_metadatos)
        ? { ...m, valor: campo.valor }
        : m
    ));
    setInputsValues(prev => prev.map(m =>
      String(m.id) === String(campo.id_metadatos)
        ? { ...m, valor: campo.valor }
        : m
    ));
    data.onOcrApply && data.onOcrApply(campo.globalIdx);
    setLocalOcrCampos(prev => prev.map(c => c.globalIdx === campo.globalIdx ? { ...c, applied: true } : c));
  };

  const applyAllOcrFields = () => {
    const umbral = data.ocrUmbral ?? 80;
    const pendientes = localOcrCampos.filter(
      c => !c.applied && c.id_metadatos && c.valor && c.confianza !== null && c.confianza >= umbral
    );
    if (pendientes.length === 0) return;

    const appliedIds = new Set(pendientes.map(c => c.globalIdx));
    const updater = prev => prev.map(m => {
      const match = pendientes.find(c => String(c.id_metadatos) === String(m.id));
      return match && (!m.valor || m.valor === '') ? { ...m, valor: match.valor } : m;
    });
    setMetadatosList(updater);
    setInputsValues(updater);
    data.setMetadatos && data.setMetadatos(updater(metadatosList));
    setLocalOcrCampos(prev => prev.map(c => appliedIds.has(c.globalIdx) ? { ...c, applied: true } : c));
    pendientes.forEach(c => data.onOcrApply && data.onOcrApply(c.globalIdx));
  };

  const updateLocalOcrValor = (globalIdx, newValor) => {
    setLocalOcrCampos(prev => prev.map(c => c.globalIdx === globalIdx ? { ...c, valor: newValor } : c));
  };

  const getOcrChipColor = (confianza) => {
    if (confianza === null || confianza === undefined) return 'default';
    if (confianza >= 80) return 'success';
    if (confianza >= 50) return 'warning';
    return 'error';
  };

  const seleccionarContenido = (preferencias) => {
    let seleccionado = null;
    for (const contenido of preferencias) {
      if (seleccionado === null || contenido.detalle !== 'Estandar') {
        seleccionado = contenido;
      } else if (contenido.detalle === 'Estandar' && seleccionado.detalle === 'Estandar') {
        if (parseInt(contenido.id) < parseInt(seleccionado.id)) {
          seleccionado = contenido;
        }
      }
    }
    return seleccionado;
  };

  useEffect(() => {
    const getTipoContenido = async () => {
      setIsLoadingData(true);
      if (idTipoContenido) {
        setTtipoContenidoSelect(objTipoContenido ? objTipoContenido : '');
      } else {
        const contenidoPreseleccionado = seleccionarContenido(tiposContenidos);
        setTtipoContenidoSelect(contenidoPreseleccionado ? contenidoPreseleccionado : '');
      }
      setIsLoadingData(false);
      setActualizarOptions(false);
    };

    getTipoContenido();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_cuentas_localizaciones, actualizarOptions]);

  useEffect(() => {
    const getMetadatos = async () => {
      setIsLoadingData(true);

      let response = await getMetadatosWhereIdTipoContenidos(tipoContenidoSelectt.id);
      let valuesMetadatosEdit = registroSeleccionado?.meta_datos
        ? registroSeleccionado.meta_datos
        : undefined;

      const responseMetadatos = response.map((metadato) => {
        let valor = "";
        let id_metadato = "";
        if (valuesMetadatosEdit) {
          for (var i = 0; i < valuesMetadatosEdit.length; i++) {
            if (valuesMetadatosEdit[i].id === metadato.id) {
              valor = valuesMetadatosEdit[i].valor;
              id_metadato = valuesMetadatosEdit[i].id;
              break;
            }
          }
        }
        return { ...metadato, valor: valor, id_metadato: id_metadato };
      });

      setMetadatosList(responseMetadatos);
      data.setMetadatos && data.setMetadatos(responseMetadatos);
      setInputsValues(responseMetadatos);
      setIsLoadingData(false);
    };

    if (tipoContenidoSelectt && tipoContenidoSelectt !== "" && !Array.isArray(tipoContenidoSelectt)) {
      getMetadatos();
      setContenidosInfo({ ...contenidosInfo, id_tipo_contenidos: tipoContenidoSelectt });
    } else {
      setMetadatosList([]);
      data.setMetadatos && data.setMetadatos([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoContenidoSelectt]);

  useEffect(() => {
    const metadatosValues = inputsValues
      .filter(input => input.valor !== "" || input.id_metadato !== "")
      .map(input => ({
        id: input.id_metadato,
        id_metadatos: input.id,
        valor: moment(input.valor, 'DD-MM-YYYY', true).isValid()
          ? moment(input.valor, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : input.valor,
        id_tipo_contenidos: tipoContenidoSelectt.id,
        tipo_contenidos: tipoContenidoSelectt.id + " - " + tipoContenidoSelectt.detalle,
      }));

    setContenidosInfo({ ...contenidosInfo, meta_datos: metadatosValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValues]);

  const toggleModal = () => {
    toggleModalContenidosForm();
    setTtipoContenidoSelect(null);
  };

  const handleSubmit = async () => {
    let datosLimpios = inputsValues.filter(item => item.valor !== "");
    if (datosLimpios.length === 0) {
      datosLimpios = inputsValues.filter(item => item.valor === "");
    }
    updateList(registroSeleccionado.id, datosLimpios, tipoContenidoSelectt);
  };

  const handleChange = (event, newValue) => {
    setTtipoContenidoSelect(newValue);
  };

  const handleClear = () => {
    setTtipoContenidoSelect(null);
    setObjTipoContenido(null);
  };

  const estilosSelect = {
    fontSize: "1em",
    color: "#646464",
    fontFamily: 'Roboto, sans-serif',
    backgroundColor: 'white',
    borderRadius: 10,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  };

  const umbral = data.ocrUmbral ?? 80;
  const camposPendientesConMapa = localOcrCampos.filter(
    c => !c.applied && c.id_metadatos && c.valor && c.confianza !== null && c.confianza >= umbral
  );

  if (isLoadingData && !data.ImportFile) {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <div>
      <LoadingOverlay open={loadingSubmit} />

      {/* Selector de tipo de contenido */}
      <Grid container>
        <Grid item xs={12}>
          <FormControl sx={{ mt: 1, minWidth: "100%" }} size="small">
            <Autocomplete
              size="small"
              value={tipoContenidoSelectt || null}
              onChange={handleChange}
              options={tiposContenidos || []}
              disabled={objTipoContenido ? true : false}
              style={data.ImportFile ? estilosSelect : null}
              getOptionLabel={(option) => option.id + ' - ' + option.detalle || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de Contenido"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: tipoContenidoSelectt && (
                      <IconButton
                        size="small"
                        hidden={registroSeleccionado.save ? true : false}
                        onClick={handleClear}
                        style={{ marginLeft: '-25px', color: 'rgba(0, 0, 0, 0.54)' }}
                      >
                        <ClearIcon />
                      </IconButton>
                    ),
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* Sección OCR */}
      {localOcrCampos.length > 0 && (
        <Box sx={{ mt: 2, mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                Extracción OCR
              </Typography>
              <Tooltip title="Nivel de confianza mínimo para aplicar automáticamente">
                <Chip
                  label={`Umbral: ${umbral}%`}
                  size="small"
                  variant="outlined"
                  color="info"
                />
              </Tooltip>
            </Box>
            {camposPendientesConMapa.length > 0 && (
              <Button
                size="small"
                variant="outlined"
                color="success"
                onClick={applyAllOcrFields}
              >
                Aplicar todos ({camposPendientesConMapa.length})
              </Button>
            )}
          </Box>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: 'rgba(0,0,0,0.04)' }}>
                  <TableCell sx={{ fontWeight: 600, width: '20%' }}>Campo</TableCell>
                  <TableCell sx={{ fontWeight: 600, width: '22%' }}>Metadato destino</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Valor OCR</TableCell>
                  <TableCell sx={{ fontWeight: 600, width: '80px', textAlign: 'center' }}>Confianza</TableCell>
                  <TableCell sx={{ fontWeight: 600, width: '110px', textAlign: 'center' }}>Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localOcrCampos.map((campo) => (
                  <TableRow
                    key={campo.globalIdx}
                    sx={{
                      backgroundColor: campo.applied
                        ? 'rgba(76, 175, 80, 0.08)'
                        : !campo.id_metadatos
                          ? 'rgba(0, 0, 0, 0.03)'
                          : 'inherit',
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2">{campo.campo}</Typography>
                    </TableCell>
                    <TableCell>
                      {campo.label_metadatos
                        ? <Typography variant="body2">{campo.label_metadatos}</Typography>
                        : <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>Sin mapeo</Typography>
                      }
                    </TableCell>
                    <TableCell>
                      <input
                        value={campo.valor}
                        onChange={(e) => updateLocalOcrValor(campo.globalIdx, e.target.value)}
                        disabled={campo.applied}
                        style={{
                          width: '100%',
                          border: '1px solid #ccc',
                          borderRadius: 4,
                          padding: '3px 8px',
                          fontSize: '0.8125rem',
                          fontFamily: 'inherit',
                          backgroundColor: campo.applied ? 'rgba(0,0,0,0.05)' : 'transparent',
                          color: 'inherit',
                          outline: 'none',
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      {campo.confianza !== null && campo.confianza !== undefined ? (
                        <Chip
                          label={`${Math.round(campo.confianza)}%`}
                          size="small"
                          color={getOcrChipColor(campo.confianza)}
                        />
                      ) : (
                        <Typography variant="caption" color="text.disabled">—</Typography>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      {campo.applied ? (
                        <Chip label="Aplicado" size="small" color="success" variant="outlined" />
                      ) : (
                        <Tooltip
                          title={!campo.id_metadatos ? 'Este campo no tiene metadato destino configurado' : ''}
                          disableHoverListener={!!campo.id_metadatos}
                        >
                          <span>
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              disabled={!campo.id_metadatos}
                              onClick={() => applyOcrField(campo)}
                            >
                              Aplicar
                            </Button>
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* Separador antes del formulario de metadatos */}
      {localOcrCampos.length > 0 && metadatosList.length > 0 && (
        <Divider sx={{ my: 2 }}>
          <Typography variant="caption" color="text.secondary">Metadatos</Typography>
        </Divider>
      )}

      <ContenidosFormDinamico
        data={data}
        inputsListValues={metadatosList}
        toggleModal={toggleModal}
        setInputsValues={setInputsValues}
        handleSubmit={handleSubmit}
        contenidoSeleccionado={data.contenidoSeleccionado}
        selectorCajas={false}
      />

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => setSnackbarVisible(false)}
      />
    </div>
  );
};
